export function scrubPII(value: string): string {
    return value
        .replace(/([?&](token|api_key|apikey|access_token|auth|password)=)[^&]*/gi, '$1[REDACTED]')
        .replace(/Bearer\s+[\w\-.]+/gi, 'Bearer [REDACTED_TOKEN]')
        .replace(/\b\d{4}[\s-]?\d{4}[\s-]?\d{4}[\s-]?\d{4}\b/g, '[REDACTED_CARD]');
}
